<template>
  <section>
    <!--工具条-->
    <el-col :span="15" class="toolbar">
      <el-button type="primary" size="small" @click="addHandler">新增</el-button>
            <el-button type="success" size="small" :disabled="this.sels.length===0" @click="batchStatusHandler(1)">批量上架</el-button>
  <el-button type="danger" size="small" :disabled="this.sels.length===0" @click="batchStatusHandler(0)">批量下架</el-button>
       <el-select v-model="selectDianpu" placeholder="店铺" size="small" style="width: 150px">
           <el-option key="0" label="全部" value="0"></el-option>
        <el-option
          v-for="(item, index) in dianpuList"
          :key="index"
          :label="item.label"
          :value="item.value"
          size="small">
        </el-option>
      </el-select>
           <el-select v-model="selectIndexStatus" placeholder="首页分类" size="small" style="width: 150px">
        <el-option key="0" label="无" value="0"></el-option>
        <el-option
          v-for="(item, index) in indexStatus"
          :key="index"
          :label="item"
          :value="index"
          size="small">
        </el-option>
      </el-select>
            <el-select v-model="selectProStatus" placeholder="是否上架" size="small" style="width: 150px">
        <el-option key="0" label="全部" value="200"></el-option>
        <el-option
          v-for="(item, index) in proStatus"
          :key="index"
          :label="item"
          :value="index"
          size="small">
        </el-option>
      </el-select>
             <el-select v-model="selectWhite" placeholder="是否白名单" size="small" style="width: 150px">
           <el-option key="0" label="全部" value="0"></el-option>
        <el-option
          v-for="(item, index) in iswhiteProStatus"
       :key="index"
          :label="item"
          :value="index"
          size="small">
        </el-option>
      </el-select>
            <el-button type="primary"  size="small" @click="search">查询</el-button>
      <el-button size="small" @click="export2Excel">导出数据</el-button>

    </el-col>

    <el-col :span="6" class="toolbar rightsearch">
      <el-input placeholder="搜索" size="small" v-model="query" @change="search">
        <el-button slot="append" icon="search" @click="search"></el-button></el-input>
    </el-col>
<el-table :data="tableData" border v-loading="listLoading" @selection-change="handleSelectionChange">
  <el-table-column type="selection" width="80"  align="center">
      </el-table-column>
      <el-table-column
        label="商品编号"
        prop="pro_id"
        align="center">
      </el-table-column>
      <el-table-column
        label="商品名称"
        prop="pro_name"
        align="center"
        min-width="300">
      </el-table-column>
       <el-table-column
        label="首页分类"
        prop="category_name"
        align="center">
     </el-table-column>
      <el-table-column
        label="品牌"
        prop="brand_name"
        align="center">
      </el-table-column>
      <el-table-column
        label="分类"
        prop="sec_name"
        align="center">
      </el-table-column>
<el-table-column
  label="默认规格"
  align="center"
  width="150">
  <template scope="scope">
    <div style="padding: 5px 0; line-height: 28px;">
      
      <div style="margin-bottom: 4px;">
        <span style="font-size: 12px; color: #606266; margin-right: 4px;">市场价:</span>
        <el-button 
          v-if="Number(scope.row.market_price) <= 100" 
          type="success" 
          size="mini" 
          style="cursor: default; padding: 3px 8px;">
          ￥{{ scope.row.market_price }}
        </el-button>
        <el-button 
          v-else 
          type="danger" 
          size="mini" 
          style="cursor: default; padding: 3px 8px;">
          ￥{{ scope.row.market_price }}
        </el-button>
      </div>
      <div style="margin-bottom: 4px;">
        <span style="font-size: 12px; color: #606266; margin-right: 4px;">宠品价:</span>
        <el-button 
          v-if="Number(scope.row.cpprice) <= 100" 
          type="success" 
          size="mini" 
          style="cursor: default; padding: 3px 8px;">
          ￥{{ scope.row.cpprice }}
        </el-button>
        <el-button 
          v-else 
          type="danger" 
          size="mini" 
          style="cursor: default; padding: 3px 8px;">
          ￥{{ scope.row.cpprice }}
        </el-button>
      </div>


      <div style="margin-bottom: 4px;">
        <span style="font-size: 12px; color: #606266; margin-right: 4px;">成本价:</span>
        <el-button 
          v-if="Number(scope.row.cost) <= 100" 
          type="success" 
          size="mini" 
          style="cursor: default; padding: 3px 8px;">
          ￥{{ scope.row.cost }}
        </el-button>
        <el-button 
          v-else 
          type="danger" 
          size="mini" 
          style="cursor: default; padding: 3px 8px;">
          ￥{{ scope.row.cost }}
        </el-button>
      </div>

<div style="margin-bottom: 4px;">
        <span style="font-size: 12px; color: #606266; margin-right: 4px;">利润值:</span>
        <el-button 
          v-if="(Number(scope.row.cpprice) - Number(scope.row.cost)) < 0" 
          type="danger" 
          size="mini" 
          style="cursor: default; padding: 3px 8px;">
          ￥{{ (Number(scope.row.cpprice) - Number(scope.row.cost)).toFixed(0) }}
        </el-button>
        <el-button 
          v-else 
          type="success" 
          size="mini" 
          style="cursor: default; padding: 3px 8px;">
          ￥{{ (Number(scope.row.cpprice) - Number(scope.row.cost)).toFixed(0) }}
        </el-button>
      </div>

      <div>
        <span style="font-size: 12px; color: #606266; margin-right: 4px;">库存:</span>
        <el-button 
          v-if="Number(scope.row.inventory) <= 10" 
          type="warning" 
          size="mini" 
          style="cursor: default; padding: 3px 8px;">
          {{ scope.row.inventory }} 件
        </el-button>
        <el-button 
          v-else 
          type="primary" 
          size="mini" 
          style="cursor: default; padding: 3px 8px;">
          {{ scope.row.inventory }} 件
        </el-button>
      </div>

    </div>
  </template>
</el-table-column>
         <el-table-column
        label="是否包邮"
          align="center">
            <template scope="scope">
          <el-button type="primary" v-if="scope.row.is_baoyou == 1"  size="small" >包邮</el-button>
           <el-button type="danger" v-if="scope.row.is_baoyou == 0"  size="small" > 不包邮</el-button>
        </template>
      </el-table-column>
      <el-table-column
        label="商品状态"
        align="center">
          <template scope="scope">
          <el-button type="primary" v-if="scope.row.pro_status == 1"  size="small" >已上架</el-button>
           <el-button type="danger" v-if="scope.row.pro_status == 0"  size="small" > 未上架</el-button>
        </template>
      </el-table-column>
<!--              <el-table-column
        label="发货方式"
        prop="is_oversea"
        align="center"
        min-width="110"> 
             <template scope="scope">
          <el-button type="primary" v-if="scope.row.is_oversea == 1"  size="small" >国内现货</el-button>
           <el-button type="danger" v-if="scope.row.is_oversea == 0"  size="small" > 保税直邮</el-button>
        </template>
      </el-table-column> -->
       <el-table-column
        label="推荐状态"
        prop="recommend"
        align="center"> 
        <template scope="scope">
          <div>{{recommendStatus[scope.row.recommend]}}</div>
        </template>
      </el-table-column>
      <el-table-column
        label="店铺"
        prop="dianpu_name"
        align="center">
      </el-table-column>
      <el-table-column
        label="关联商品ID"
        prop="referer_proid"
        align="center">
      </el-table-column>
        <el-table-column
        label="关联规格ID"
        prop="referer_specid"
        align="center">
      </el-table-column>
       <el-table-column
        label="创建时间"
        prop="create_time"
        align="center">
      </el-table-column>
        <el-table-column
        label="更新时间"
        prop="update_time"
        align="center">
      </el-table-column>
      <el-table-column
        label="备注"
        prop="remark"
        align="center">
      </el-table-column>
      <el-table-column
        label="操作"
        prop="labels"
        align="center"
        min-width="250">
        <template scope="scope">
           
       <!-- 确保这一行在你的商品列表 el-table 中 -->
<el-button size="small" @click="editSpecHandler(scope.row.pro_id)">修改规格</el-button>
       <!--   <el-button :plain="true" type="info" size="small" @click="showGoodsForm(scope.row)">关联商品</el-button> -->
          <el-button  size="small"  @click="editHandler(scope.row)">修改</el-button>
             <el-button size="small" @click="updatePro(scope.row)">更新宝贝</el-button>
                      <el-button  size="small" @click="onekeyCopy(scope.row.pro_id)">一键复制</el-button>
   <el-button  v-if="scope.row.remark == '' " size="small"  type="primary"  @click="setWhiteList(scope.row.pro_id)">设白名单</el-button>
      <el-button  v-if="scope.row.remark != '' " size="small"  type="success"  @click="deleteRemark(scope.row.pro_id)">清备上架</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-col :span="0" class="toolbar_page">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[10, 15, 20, 30]"
        :page-size="pageSize"
        layout="sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </el-col>

    <!--新增界面-->
    <el-dialog title="新增" v-model="addFormVisible" size="large">
      <el-form :model="addForm" label-width="150px" :rules="formRules" ref="addForm">
        <el-form-item label="商品名称" prop="pro_name">
          <el-input v-model="addForm.pro_name" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="品牌" prop="brand_id">
          <el-select v-model="addForm.brand_id" placeholder="请选择">
            <el-option
              v-for="item in brand"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
         <el-form-item label="首页分类" prop="category_id">
          <el-select v-model="addForm.category_id" placeholder="请选择">
            <el-option
              v-for="item in indexcategory"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级分类" prop="sec_id">
          <el-select v-model="addForm.sec_id" placeholder="请选择">
            <el-option
              v-for="item in secondMenu"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
     <!--    <el-form-item label="重量" prop="weight">
          <el-input v-model="addForm.weight" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="适用什么宠物" prop="suit_pet">
          <el-input v-model="addForm.suit_pet" auto-complete="off" size="small" required></el-input>
        </el-form-item> -->
        <el-form-item label="商品主图" prop="pro_mainpic">
          <el-upload
            class="avatar-uploader"
            action="https://up.qbox.me"
            :show-file-list='showUploadList'
            :on-success="mainHandleSuccess"
            :on-error="mainHandleError"
            :before-upload="mainBeforeUpload"
            :data='uploadForm'>
            <img v-if="mainPicUrl" :src="mainPicUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
<el-form-item label="商品图片" prop="pro_pic">
    <el-upload
      multiple
      action="https://up.qbox.me"
      :on-success="(res, file, fileList) => handleUploadSuccess(res, file, fileList, 'pro')"
      :on-error="(err, file, fileList) => handleUploadError(err, file, fileList, 'pro')"
      :on-remove="removePicPro"
      :before-upload="(file) => handleBeforeUpload(file, 'pro')"
      :data='uploadForm'
      :file-list="fileListPro"
      list-type="picture"
      :show-file-list="false"> <el-button size="small" type="primary">点击多选上传</el-button>
    </el-upload>
        
        <div class="image-sort-container" v-if="fileListPro.length > 0">
          <div v-for="(file, index) in fileListPro" :key="index" class="image-sort-item">
            <img :src="file.url" class="sort-img">
            <div class="sort-btns">
              <el-button type="text" size="mini" icon="el-icon-arrow-left" :disabled="index === 0" @click="moveImage('pro', index, 'up')">前移</el-button>
              <el-button type="text" size="mini" icon="el-icon-arrow-right" :disabled="index === fileListPro.length - 1" @click="moveImage('pro', index, 'down')">后移</el-button>
              <el-button type="text" size="mini" style="color: #ff4949" @click="deleteImage('pro', index)">删除</el-button>
            </div>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="商品详情图片" prop="prointro_pic">
<el-upload
  multiple
  action="https://up.qbox.me"
  :on-success="(res, file, fileList) => handleUploadSuccess(res, file, fileList, 'intro')"
  :on-error="(err, file, fileList) => handleUploadError(err, file, fileList, 'intro')"
  :on-remove="removePicProintro"
  :before-upload="(file) => handleBeforeUpload(file, 'intro')"
  :data='uploadForm'
  :file-list="fileListProintro"
  list-type="picture"
  :show-file-list="false"> <el-button size="small" type="primary">点击多选上传</el-button>
</el-upload>
        
        <div class="image-sort-container" v-if="fileListProintro.length > 0">
          <div v-for="(file, index) in fileListProintro" :key="index" class="image-sort-item">
            <img :src="file.url" class="sort-img">
            <div class="sort-btns">
              <el-button type="text" size="mini" icon="el-icon-arrow-left" :disabled="index === 0" @click="moveImage('intro', index, 'up')">前移</el-button>
              <el-button type="text" size="mini" icon="el-icon-arrow-right" :disabled="index === fileListProintro.length - 1" @click="moveImage('intro', index, 'down')">后移</el-button>
              <el-button type="text" size="mini" style="color: #ff4949" @click="deleteImage('intro', index)">删除</el-button>
            </div>
          </div>
        </div>
      </el-form-item>
<!--         <el-form-item label="商品销量" prop="prosales">
          <el-input v-model="addForm.prosales" auto-complete="off" size="small" required></el-input>
        </el-form-item> -->
        <el-form-item label="商品状态" prop="pro_status">
          <el-switch
            v-model="addForm.pro_status"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'>
          </el-switch>
        </el-form-item>
        <el-form-item label="推荐状态" prop="recommend">
          <el-select v-model="addForm.recommend" placeholder="请选择">
            <el-option
              v-for="(item, index) in recommendStatus"
              :key="index"
              :label="item"
              :value="index"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>

       <!--  
        <el-form-item label="备案价" prop="beianjia">
          <el-input v-model="addForm.beianjia" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="原产地" prop="origin_place">
          <el-input v-model="addForm.origin_place" auto-complete="off" size="small" required></el-input>
        </el-form-item> -->

        <el-form-item label="加入购物车" prop="add_cart">
          <el-switch
            v-model="addForm.add_cart"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'>
          </el-switch>
        </el-form-item>
        <el-form-item label="五件批发" prop="five_pifa">
          <el-switch
            v-model="addForm.five_pifa"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'>
          </el-switch>
        </el-form-item>
        <el-form-item label="一件代发" prop="one_daifa">
          <el-switch
            v-model="addForm.one_daifa"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'>
          </el-switch>
        </el-form-item>
        <el-form-item label="是否包邮" prop="is_baoyou">
          <el-switch
            v-model="addForm.is_baoyou"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'>
          </el-switch>
        </el-form-item>
        <el-form-item label="快递模版" prop="moban_id" v-if="addForm.is_baoyou === '0'">
          <el-select v-model="addForm.moban_id" placeholder="请选择" style="width: 100%;">
            <el-option
              v-for="item in mobanArr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属店铺" prop="dianpu_id">
          <el-select v-model="addForm.dianpu_id" placeholder="请选择" style="width: 100%;">
            <el-option
              v-for="item in dianpuList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="仓库" prop="is_oversea">
          <el-select v-model="addForm.is_oversea" placeholder="请选择" style="width: 100%;">
            <el-option
              v-for="(item, index) in overseaArr"
              :key="index"
              :label="item"
              :value="index"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="UPC" prop="upc">
          <el-input v-model="addForm.upc" auto-complete="off" size="small" required></el-input>
        </el-form-item>
          <el-form-item label="关联商品ID" prop="referer_proid">
          <el-input v-model="addForm.referer_proid" auto-complete="off" size="small" required></el-input>
        </el-form-item>
             </el-form-item>
          <el-form-item label="关联规格ID" prop="referer_specid">
          <el-input v-model="addForm.referer_specid" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <div class="spec_border">
          <el-row>
            <el-col :span="12">
              <el-form-item label="商品规格">
                <el-select v-model="prospecForm.spec_name" placeholder="请选择" style="width: 100%;">
                  <el-option
                    v-for="item in prospecArr"
                    :key="item.label"
                    :label="item.label"
                    :value="item.label"
                    size="small">
                  </el-option>
                </el-select>
                <div class="el-form-item__error">必选,可新增不同规格 如 16kg 32kg  一包  两包</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="库存">
                <el-input v-model="prospecForm.inventory" auto-complete="off" size="small" required></el-input>
                <div class="el-form-item__error">必填</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="市场价">
                <el-input v-model="prospecForm.market_price" auto-complete="off" size="small" required></el-input>
                <div class="el-form-item__error">必填</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="宠品价">
                <el-input v-model="prospecForm.cpprice" auto-complete="off" size="small" required></el-input>
                <div class="el-form-item__error">必填</div>
              </el-form-item>
            </el-col>
          </el-row>
               <el-row>
            <el-col :span="12">
              <el-form-item label="成本价">
                <el-input v-model="prospecForm.cost" auto-complete="off" size="small" required></el-input>
                <div class="el-form-item__error">必填</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="是否默认">
                <el-switch
                  v-model="prospecForm.is_default"
                  on-color="#13ce66"
                  off-color="#bfcbd9"
                  on-value='1'
                  off-value='0'>
                </el-switch>
                <div class="el-form-item__error">商品必选一个默认规格</div>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="padding: 5px 0 0 150px;">
              <el-button type="primary" @click="saveSpec" size="small">保存规格</el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-table
                :data="prospecTable">
                <el-table-column
                  prop="spec_name"
                  label="规格">
                </el-table-column>
                <el-table-column
                  prop="market_price"
                  label="市场价">
                </el-table-column>
                <el-table-column
                  prop="cpprice"
                  label="宠品价">
                </el-table-column>
                 <el-table-column
                  prop="cost"
                  label="成本价">
                </el-table-column>
                <el-table-column
                  prop="inventory"
                  label="库存">
                </el-table-column>
                <el-table-column
                  prop="is_default"
                  label="是否默认">
                  <template scope="scope">
                    <div>{{isDefault[scope.row.is_default]}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作">
                  <template scope="scope">
                    <el-button size="small" :plain="true" type="danger" @click="deleteSpec(scope.row.id, scope.row.index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </div>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="addForm.remark" auto-complete="off" size="small" required></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="addSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--编辑界面-->
    <el-dialog title="编辑" v-model="editFormVisible" size="large">
      <el-form :model="editForm" label-width="150px" :rules="formRules" ref="editForm">
        <el-form-item label="商品名称" prop="pro_name">
          <el-input v-model="editForm.pro_name" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="品牌" prop="brand_id">
          <el-select v-model="editForm.brand_id" placeholder="请选择">
            <el-option
              v-for="item in brand"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="首页分类" prop="category_id">
          <el-select v-model="editForm.category_id" placeholder="请选择">
            <el-option
              v-for="item in indexcategory"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二级分类" prop="sec_id">
          <el-select v-model="editForm.sec_id" placeholder="请选择">
            <el-option
              v-for="item in secondMenu"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
  <!--       <el-form-item label="重量" prop="weight">
          <el-input v-model="editForm.weight" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="适用什么宠物" prop="suit_pet">
          <el-input v-model="editForm.suit_pet" auto-complete="off" size="small" required></el-input>
        </el-form-item> -->
        <el-form-item label="商品主图" prop="pro_mainpic">
          <el-upload
            class="avatar-uploader"
            action="https://up.qbox.me"
            :show-file-list='showUploadList'
            :on-success="mainHandleSuccess"
            :on-error="mainHandleError"
            :before-upload="mainBeforeUpload"
            :data='uploadForm'>
            <img v-if="mainPicUrl" :src="mainPicUrl" class="avatar">
            <i v-else class="el-icon-plus avatar-uploader-icon"></i>
          </el-upload>
        </el-form-item>
       <el-form-item label="商品图片" prop="pro_pic">
<el-upload
  multiple
  action="https://up.qbox.me"
  :on-success="(res, file, fileList) => handleUploadSuccess(res, file, fileList, 'pro')"
  :on-error="(err, file, fileList) => handleUploadError(err, file, fileList, 'pro')"
  :on-remove="removePicPro"
  :before-upload="(file) => handleBeforeUpload(file, 'pro')"
  :data='uploadForm'
  :file-list="fileListPro"
  list-type="picture"
  :show-file-list="false"> <el-button size="small" type="primary">点击多选上传</el-button>
</el-upload>
        
        <div class="image-sort-container" v-if="fileListPro.length > 0">
          <div v-for="(file, index) in fileListPro" :key="index" class="image-sort-item">
            <img :src="file.url" class="sort-img">
            <div class="sort-btns">
              <el-button type="text" size="mini" icon="el-icon-arrow-left" :disabled="index === 0" @click="moveImage('pro', index, 'up')">前移</el-button>
              <el-button type="text" size="mini" icon="el-icon-arrow-right" :disabled="index === fileListPro.length - 1" @click="moveImage('pro', index, 'down')">后移</el-button>
              <el-button type="text" size="mini" style="color: #ff4949" @click="deleteImage('pro', index)">删除</el-button>
            </div>
          </div>
        </div>
      </el-form-item>

      <el-form-item label="商品详情图片" prop="prointro_pic">
<el-upload
  multiple
  action="https://up.qbox.me"
  :on-success="(res, file, fileList) => handleUploadSuccess(res, file, fileList, 'intro')"
  :on-error="(err, file, fileList) => handleUploadError(err, file, fileList, 'intro')"
  :on-remove="removePicProintro"
  :before-upload="(file) => handleBeforeUpload(file, 'intro')"
  :data='uploadForm'
  :file-list="fileListProintro"
  list-type="picture"
  :show-file-list="false"> <el-button size="small" type="primary">点击多选上传</el-button>
</el-upload>
        
        <div class="image-sort-container" v-if="fileListProintro.length > 0">
          <div v-for="(file, index) in fileListProintro" :key="index" class="image-sort-item">
            <img :src="file.url" class="sort-img">
            <div class="sort-btns">
              <el-button type="text" size="mini" icon="el-icon-arrow-left" :disabled="index === 0" @click="moveImage('intro', index, 'up')">前移</el-button>
              <el-button type="text" size="mini" icon="el-icon-arrow-right" :disabled="index === fileListProintro.length - 1" @click="moveImage('intro', index, 'down')">后移</el-button>
              <el-button type="text" size="mini" style="color: #ff4949" @click="deleteImage('intro', index)">删除</el-button>
            </div>
          </div>
        </div>
      </el-form-item>
       <!--  <el-form-item label="商品销量" prop="prosales">
          <el-input v-model="editForm.prosales" auto-complete="off" size="small" required></el-input>
        </el-form-item> -->
        <el-form-item label="商品状态" prop="pro_status">
          <el-switch
            v-model="editForm.pro_status"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'>
          </el-switch>
        </el-form-item>
        <el-form-item label="推荐状态" prop="recommend">
          <el-select v-model="editForm.recommend" placeholder="请选择">
            <el-option
              v-for="(item, index) in recommendStatus"
              :key="index"
              :label="item"
              :value="index"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
       <!--  
        <el-form-item label="备案价" prop="beianjia">
          <el-input v-model="editForm.beianjia" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="原产地" prop="origin_place">
          <el-input v-model="editForm.origin_place" auto-complete="off" size="small" required></el-input>
        </el-form-item> -->
       
        <el-form-item label="加入购物车" prop="add_cart">
          <el-switch
            v-model="editForm.add_cart"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'>
          </el-switch>
        </el-form-item>
        <el-form-item label="五件批发" prop="five_pifa">
          <el-switch
            v-model="editForm.five_pifa"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'>
          </el-switch>
        </el-form-item>
        <el-form-item label="一件代发" prop="one_daifa">
          <el-switch
            v-model="editForm.one_daifa"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'>
          </el-switch>
        </el-form-item>
        <el-form-item label="是否包邮" prop="is_baoyou">
          <el-switch
            v-model="editForm.is_baoyou"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'>
          </el-switch>
        </el-form-item>
        <el-form-item label="快递模版" prop="moban_id" v-if="editForm.is_baoyou === '0'">
          <el-select v-model="editForm.moban_id" placeholder="请选择" style="width: 100%;">
            <el-option
              v-for="item in mobanArr"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
         <el-form-item label="所属店铺" prop="dianpu_id" >
          <el-select v-model="editForm.dianpu_id" placeholder="请选择" style="width: 100%;">
            <el-option
              v-for="item in dianpuList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
         <el-form-item label="仓库" prop="is_oversea">
          <el-select v-model="editForm.is_oversea" placeholder="请选择" style="width: 100%;">
            <el-option
              v-for="(item, index) in overseaArr"
              :key="index"
              :label="item"
              :value="index"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="UPC" prop="upc">
          <el-input v-model="editForm.upc" auto-complete="off" size="small" required></el-input>
        </el-form-item>
          <el-form-item label="关联商品ID" prop="referer_proid">
          <el-input v-model="editForm.referer_proid" auto-complete="off" size="small" required></el-input>
        </el-form-item>
             <el-form-item label="关联规格ID" prop="referer_specid">
          <el-input v-model="editForm.referer_specid" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <div class="spec_border">
          <el-row>
            <el-col :span="12">
              <el-form-item label="商品规格">
                <el-select v-model="prospecForm.spec_name" placeholder="请选择" style="width: 100%;">
                  <el-option
                    v-for="item in prospecArr"
                    :key="item.label"
                    :label="item.label"
                    :value="item.label"
                    size="small">
                  </el-option>
                </el-select>
                <div class="el-form-item__error">必选,可新增不同规格 如 16kg 32kg  一包  两包</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="库存">
                <el-input v-model="prospecForm.inventory" auto-complete="off" size="small" required></el-input>
                <div class="el-form-item__error">必填</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="市场价">
                <el-input v-model="prospecForm.market_price" auto-complete="off" size="small" required></el-input>
                <div class="el-form-item__error">必填</div>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="宠品价">
                <el-input v-model="prospecForm.cpprice" auto-complete="off" size="small" required></el-input>
                <div class="el-form-item__error">必填</div>
              </el-form-item>
            </el-col>
          </el-row>
            <el-row>
            <el-col :span="12">
              <el-form-item label="成本价">
                <el-input v-model="prospecForm.cost" auto-complete="off" size="small" required></el-input>
                <div class="el-form-item__error">必填</div>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="12">
              <el-form-item label="是否默认">
                <el-switch
                  v-model="prospecForm.is_default"
                  on-color="#13ce66"
                  off-color="#bfcbd9"
                  on-value='1'
                  off-value='0'>
                </el-switch>
                <div class="el-form-item__error">商品必选一个默认规格</div>
              </el-form-item>
            </el-col>
            <el-col :span="12" style="padding: 5px 0 0 150px;">
              <el-button type="primary" @click="saveSpec" size="small">保存规格</el-button>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <el-table
                :data="prospecTable">
                <el-table-column
                  prop="spec_name"
                  label="规格">
                </el-table-column>
                <el-table-column
                  prop="market_price"
                  label="市场价">
                </el-table-column>
                <el-table-column
                  prop="cpprice"
                  label="宠品价">
                </el-table-column>
                <el-table-column
                  prop="cost"
                  label="成本价">
                </el-table-column>
                <el-table-column
                  prop="inventory"
                  label="库存">
                </el-table-column>
                <el-table-column
                  prop="is_default"
                  label="是否默认">
                  <template scope="scope">
                    <div>{{isDefault[scope.row.is_default]}}</div>
                  </template>
                </el-table-column>
                <el-table-column
                  label="操作">
                  <template scope="scope">
                    <el-button size="small" :plain="true" type="danger" @click="deleteSpec(scope.row.id, scope.row.index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-col>
          </el-row>
        </div>
        <el-form-item label="备注" prop="remark">
          <el-input type="textarea" v-model="editForm.remark" auto-complete="off" size="small" required></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="editSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

    <!--查看更新宝贝界面-->
    <el-dialog title="更新存在的宝贝(主图、分类、之类)" v-model="updateProVisible">
     <el-row>
        <el-col :offset="2" :span="4">当前宝贝编号:</el-col>
        <el-col :span="16">
          <div>{{pro_id}}</div>
        </el-col>
      </el-row>
      <el-row style="margin-top: 30px;">
        <el-col :offset="2" :span="4">复制宝贝编号:</el-col>
        <el-col :span="16">
          <el-input  rows="3" v-model="copy_proid" placeholder="复制已存在的宝贝ID"></el-input>
        </el-col>
      </el-row>
       <el-row style="margin-top: 30px;">
              <el-col :offset="2" :span="4">是否复制标题</el-col>
              <el-col :span="16">
          <el-switch
            v-model="copy_title"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'>
          </el-switch>
           </el-col>
   </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="updateProSubmit" :loading="submitLoading">确认</el-button>
      </div>
    </el-dialog>

    <!--选择商品页面-->
    <el-dialog title="选择商品" v-model="selectGoodsVisible">
      <div class="select-goods">
        <el-tree class="goods-tree" highlight-current :data="goodsTypeData" @node-click="handleNodeClick"></el-tree>
        <div class="goods-data">
          <el-checkbox-group v-model="selectGoodsData" v-if="goodsData && goodsData.length > 0">
            <el-checkbox v-for="item of goodsData" :label="item.name+'-'+item.value" :key="item.value" ></el-checkbox>
          </el-checkbox-group>
          <div v-else class="no-goods">暂无数据</div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="selectGoodsSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>


<!-- ================= 规格管理弹窗 (整合自方案1) ================= -->
    <el-dialog title="管理商品规格" v-model="specListVisible" size="large">
      <el-table :data="specTableData" border v-loading="specListLoading">
        <el-table-column prop="spec_name" label="规格"></el-table-column>
        <el-table-column prop="market_price" label="市场价"></el-table-column>
        <el-table-column prop="cpprice" label="宠品价"></el-table-column>
        <el-table-column prop="cost" label="成本价"></el-table-column>
        <el-table-column prop="inventory" label="库存"></el-table-column>
        <el-table-column prop="is_default" label="是否默认">
          <template scope="scope">
            <div>{{isDefault[scope.row.is_default]}}</div>
          </template>
        </el-table-column>
        <el-table-column label="操作" prop="labels" align="center">
          <template scope="scope">
            <el-button size="small" type="primary" @click="specEditHandler(scope.row)">修改</el-button>
            <el-button size="small" type="danger" @click="specDeleteHandler(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button @click="specListVisible = false; search()">关闭</el-button>
      </div>
    </el-dialog>

    <!-- 规格编辑界面 (子弹窗) -->
    <el-dialog title="编辑规格信息" v-model="specEditFormVisible">
      <el-form :model="specEditForm" label-width="150px" ref="specEditForm">
        <el-form-item label="商品规格" prop="spec_name">
          <el-select v-model="specEditForm.spec_name" placeholder="请选择">
            <el-option
              v-for="item in prospecArr"
              :key="item.label"
              :label="item.label"
              :value="item.label"
              size="small">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="市场价" prop="market_price">
          <el-input v-model="specEditForm.market_price" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="宠品价" prop="cpprice">
          <el-input v-model="specEditForm.cpprice" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="成本价" prop="cost">
          <el-input v-model="specEditForm.cost" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="库存" prop="inventory">
          <el-input v-model="specEditForm.inventory" auto-complete="off" size="small" required></el-input>
        </el-form-item>
        <el-form-item label="是否默认" prop="is_default">
          <el-switch
            v-model="specEditForm.is_default"
            on-color="#13ce66"
            off-color="#bfcbd9"
            on-value='1'
            off-value='0'>
          </el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="specEditSubmit" :loading="submitLoading">提交</el-button>
      </div>
    </el-dialog>

  </section>
</template>

<script>
  import config from '../../config';
  import {formatPara} from '../../static/js/util.js';
  import {formatDate} from '../../static/js/date.js';
  import {getQiniuToken} from '../../static/js/token.js'
  import basicdata from '../../static/config/basicdata.js';

  export default {
    data() {
      return {
        tableData: [],
        sels: [], // 存储选中的商品行
        total:0,
        page:1,
        pageSize:30,
        copy_proid: '',
        copy_title: '1',
        listLoading: false,
        query: '',
        submitLoading: false,
        addFormVisible: false,
        updateProVisible: false,
        addForm: {
          pro_name: '',
          brand_id: '',
          category_id: '',
          sec_id: '',
          weight: '',
          suit_pet: '',
          pro_mainpic: '',
          pro_pic: '',
          prosales: '',
          prointro_pic: '',
          pro_status: '1',
          related_proids: '',
          remark: '',
          create_time: '',
          update_time: '',
          status: 0,
          recommend: '0',
          upc: '',
          beianjia: '',
          origin_place: '',
          is_oversea: '1',
          admin_id: 0,
          dianpu_id: '',
          add_cart: '1',
          five_pifa: '0',
          one_daifa: '1',
          is_baoyou: '1',
          moban_id: '',
          referer_proid:'',
          referer_specid:'',
        },
        editFormVisible: false,
        editForm: {},
        formRules: {},
        indexcategory:[],
        brand: [],
        secondMenu: [],
        uploadForm: {
          token: getQiniuToken(),
          key: null
        },
        imageUrl: '',
        imageName: '',
        fileListPro: [],
        fileListProintro: [],
        proPic: [],
        prointroPic: [],
        iswhiteProStatus: basicdata.iswhiteProStatus,
        recommendStatus: basicdata.recommendStatus,
        isoverseaStatus:basicdata.isoverseaStatus,
        baoyouStatus:basicdata.baoyouStatus,
        proStatus:basicdata.proStatus,
         indexStatus:basicdata.indexStatus,
        showUploadList: false,
        mainPicUrl: '',
        prospecArr: [],
        prospecForm: {
          spec_name: '',
          market_price: '',
          cpprice: '',
          cost:'',
          inventory: '908',
          is_default: '1'
        },
        selectProStatus: "200",
        isDefault: basicdata.isDefault,
        proStatus: basicdata.proStatus,
        prospecTable: [],
        proid: 0,
        selectGoodsVisible: false,
        goodsTypeData: [],
        goodsData: [],
        selectGoodsData: [],
        overseaArr: basicdata.overseaArr,
        mobanArr: [],
        dianpuList:[],
        selectDianpu: '',
         selectIndexStatus: '',
         selectWhite: '',
        currentProId: 0,            // 记录当前正在操作规格的商品ID
        specListVisible: false,     // 规格列表弹窗开关
        specListLoading: false,     // 规格列表加载状态
        specTableData: [],          // 规格列表数据
        specEditFormVisible: false, // 规格编辑子弹窗开关
        specEditForm: {},           // 正在编辑的规格表单数据
      }
    },
    methods: {
// 1. 打开规格弹窗并获取数据 (替换原有的 editSpecHandler)
      editSpecHandler(proid) {
        this.currentProId = proid;
        this.specListVisible = true;
        this.getSpecList();
      },

      // 2. 获取当前商品的规格列表
      getSpecList() {
        this.specListLoading = true;
        this.$axios.get(config.api_url + '/product/specification/' + this.currentProId)
        .then(response => {
          let data = response.data;
          if (data.state) {
            this.specTableData = data.msg;
          }
          this.specListLoading = false;
        }).catch(error => {
          console.log(error);
          this.$message.error('获取规格数据异常，请联系管理员');
          this.specListLoading = false;
        });
      },

      // 3. 规格删除操作
      specDeleteHandler(id) {
        if (id != 0) {
          this.$confirm('是否删除该规格?', '提示', { type: 'warning' }).then(() => {
            this.$axios.delete(config.api_url + '/product/specification/' + id).then(response => {
              if(!response.data.state) {
                this.$message.warning('删除规格失败');
              }
              this.getSpecList(); // 重新拉取刷新列表
            }).catch(error => {
              console.log(error);
              this.$message.error('删除规格异常');
            });
          }).catch(() => {});
        }
      },

      // 4. 打开规格修改子弹窗
      specEditHandler(row) {
        this.specEditFormVisible = true;
        this.specEditForm = Object.assign({}, row); // 浅拷贝，避免双向绑定直接污染表格
        this.specEditForm.is_default = row.is_default.toString();
      },

      // 5. 提交规格修改
      specEditSubmit() {
        this.$refs.specEditForm.validate((valid) => {
          if (valid) {
            this.submitLoading = true;
            let para = Object.assign({}, this.specEditForm);
            para.is_default = parseInt(para.is_default);
            para.inventory = parseInt(para.inventory);
            para.cpprice = parseFloat(para.cpprice);
            para.cost = parseFloat(para.cost);
            para.market_price = parseFloat(para.market_price);
            
            let paras = [para]; // 接口要求是数组格式
            
            this.$axios.put(config.api_url + '/product/specification', paras).then(response => {
              this.submitLoading = false;
              if (response.data.state) {
                this.$message.success('提交成功');
                this.specEditFormVisible = false;
                this.getSpecList(); // 刷新表格
              } else {
                this.$message.error('提交失败，请联系管理员');
              }
            }).catch(error => {
              console.log(error);
              this.submitLoading = false;
              this.$message.error('提交异常，请联系管理员');
            });
          }
        });
      },

            // 统一处理上传前逻辑：生成本地预览占位，严格保证顺序
      handleBeforeUpload(file, type) {
        let imageName = 'product/' + formatDate(new Date(), 'yyyyMMddhhmmss') + Math.random().toString(36).substr(2);
        let mime = file.name.split('.')[1];
        if(mime) {
          imageName += '.' + mime;
        }
        this.uploadForm.key = imageName;
        let qiniuUrl = basicdata.picUrl + imageName;

        // 生成本地预览地址，提前展示图片体验更好
        let localPreviewUrl = URL.createObjectURL(file);

        if (type === 'pro') {
          this.proPic.push(qiniuUrl); // 最终传给后端的真实七牛云URL数组
          this.fileListPro.push({
            name: imageName,
            url: localPreviewUrl, // 临时展示本地图片
            uid: file.uid
          });
        } else if (type === 'intro') {
          this.prointroPic.push(qiniuUrl);
          this.fileListProintro.push({
            name: imageName,
            url: localPreviewUrl,
            uid: file.uid
          });
        }
        return true;
      },

      // 统一处理上传成功逻辑：将本地预览图替换为远端七牛云链接释放内存
      handleUploadSuccess(response, file, fileList, type) {
        let targetList = type === 'pro' ? this.fileListPro : this.fileListProintro;
        let targetFile = targetList.find(item => item.uid === file.uid);
        if (targetFile) {
          targetFile.url = basicdata.picUrl + response.key;
        }
      },

      // 统一处理上传失败逻辑：移除占位图及对应的真实链接
      handleUploadError(error, file, fileList, type) {
        console.log(error);
        this.$message.error('部分图片上传异常，请检查网络或联系管理员');
        
        if (type === 'pro') {
          this.fileListPro = this.fileListPro.filter(item => item.uid !== file.uid);
          // 重构 proPic 保证数据与视图同步
          this.proPic = this.fileListPro.map(item => item.url);
        } else if (type === 'intro') {
          this.fileListProintro = this.fileListProintro.filter(item => item.uid !== file.uid);
          this.prointroPic = this.fileListProintro.map(item => item.url);
        }
      },
               // 记录选中的行
      handleSelectionChange(sels) {
        this.sels = sels;
      },
      // 批量上下架处理
      batchStatusHandler(status) {
        const text = status === 1 ? '上架' : '下架';
        const ids = this.sels.map(item => item.pro_id); // 假设后端接收商品ID数组
        
        this.$confirm(`确认批量${text}选中的 ${ids.length} 个商品吗？`, '提示', {
          type: 'warning'
        }).then(() => {
          this.listLoading = true;
          // 注意：这里的请求路由 /product/batchstatus 和入参结构需根据您的后端接口实际情况调整
          this.$axios.put(config.api_url + '/product/batchstatus', {
            ids: ids,
            pro_status: status
          }).then(response => {
            this.listLoading = false;
            if (response.data.state) {
              this.$message({ message: `批量${text}成功`, type: 'success' });
              this.search(); // 刷新列表
            } else {
              this.$message({ message: response.data.msg || `批量${text}失败`, type: 'error' });
            }
          }).catch(error => {
            this.listLoading = false;
            console.log(error);
            this.$message({ message: '批量操作异常，请联系管理员', type: 'error' });
          });
        }).catch(() => {});
      },
      // 动态调整图片顺序方法
      moveImage(type, index, direction) {
        let fileList = type === 'pro' ? this.fileListPro : this.fileListProintro;
        let picArr = type === 'pro' ? this.proPic : this.prointroPic;
        
        // 计算目标位置
        let targetIndex = direction === 'up' ? index - 1 : index + 1;
        
        // 1. 交换前端显示的 fileList 元素位置
        let tempFile = fileList[index];
        this.$set(fileList, index, fileList[targetIndex]);
        this.$set(fileList, targetIndex, tempFile);
        
        // 2. 交换实际提交给后端的 picArr 数组里的图片 URL 顺序
        let tempPic = picArr[index];
        this.$set(picArr, index, picArr[targetIndex]);
        this.$set(picArr, targetIndex, tempPic);
      },
      
      // 代替原生 remove 的删除图片方法
      deleteImage(type, index) {
        if (type === 'pro') {
          this.fileListPro.splice(index, 1);
          this.proPic.splice(index, 1);
        } else {
          this.fileListProintro.splice(index, 1);
          this.prointroPic.splice(index, 1);
        }
      },
      //分页方法
      handleSizeChange(size) {
        this.pageSize = size;
        this.search();
      },
      handleCurrentChange(page) {
        this.page = page;
        this.search();
      },
      search() {
        this.getGoodsList(this.query);
      },
      //获取商品列表
      getGoodsList(query) {
        this.listLoading = true;
        query =  this.selectDianpu + "|" + this.selectIndexStatus+ "|" + this.selectProStatus+ "|" + this.selectWhite+ "|" + query;
        this.$axios.post(config.api_url + '/product/page', {
          "page": this.page,
          "size": this.pageSize,
          "query": query
        }).then(response => {
          let data = response.data;
          if(data.state) {
            this.total = data.count;
            this.tableData = data.msg;
            this.listLoading = false;
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取数据异常，请联系管理员',
            type: 'error'
          });
          this.listLoading = false;
        })
      },
       // 导出Excel
      export2Excel() {
        let query =  this.selectDianpu + "|" + this.selectProStatus+ "|" + this.query;
        this.$axios.post(config.api_url + '/product/excel', {
          "page": this.page,
          "size": this.pageSize,
          "query": query
        }).then(response => {
          if(response.data.state) {
            if(response.data.msg) {
              console.log(response.data.msg);
              require.ensure([], () => {
                const { export_json_to_excel } = require('../../static/vendor/Export2Excel');
                const tHeader = ['商品名称', '品牌', '二级目录', '首页分类', '规格名称', '商品状态', '市场价', '宠品仓价', '库存', '店铺名称','备注','关联商品ID','关联规格ID']; //对应表格输出的title
                const filterVal = ['pro_name', 'brand_name', 'sec_name', 'category_name', 'spec_name', 'pro_status_str', 'market_price', 'price', 'inventory', 'dianpu_name','remark','referer_proid','referer_specid']; // 对应表格输出的数据
                const list = response.data.msg;
                const data = this.formatJson(filterVal, list);
                export_json_to_excel(tHeader, data, '商品列表_'+new Date().toLocaleString()); //对应下载文件的名字
              });
            } else {
              this.$message({
                message: '无数据，请联系管理员！',
                type: 'warning'
              });
            }
          } else {
            this.$message({
              message: '无数据，请联系管理员！',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '导出异常，请联系管理员！',
            type: 'error'
          });
        });
      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v => filterVal.map(j => v[j]));
      },
     
      //新增数据提交
      addSubmit() {
        this.$refs.addForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = formatPara(Object.assign({}, this.addForm));
              para.prosales = parseInt(para.prosales);
              para.pro_pic = this.proPic.toString();
              para.prointro_pic = this.prointroPic.toString();
              para.pro_status = parseInt(para.pro_status);
              para.recommend = parseInt(para.recommend);
              para.pro_mainpic = this.mainPicUrl;
              para.beianjia = parseInt(para.beianjia);
              para.add_cart = parseInt(para.add_cart);
              para.five_pifa = parseInt(para.five_pifa);
              para.one_daifa = parseInt(para.one_daifa);
              para.is_baoyou = parseInt(para.is_baoyou);
              para.moban_id = parseInt(para.moban_id);
              para.is_oversea = parseInt(para.is_oversea);
               para.referer_proid = parseInt(para.referer_proid);
                    para.referer_specid = parseInt(para.referer_specid);
              //异步请求
              this.$axios.post(config.api_url + '/product',
                para).then(response => {
                if(response.data.state) {
                  //新增商品规格
                  this.addProspec(response.data.msg)
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['addForm'].resetFields();
                  this.mainPicUrl = '';
                  this.proPic = [];
                  this.prointroPic = [];
                  this.fileListPro = [];
                  this.fileListProintro = [];
                  this.prospecTable = [];
                  this.referer_proid = '';
                   this.referer_specid = '';
                  this.addFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: '提交失败，请联系管理员',
                    type: 'warning'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },
      //修改数据弹框
      editHandler(row) {
        this.editFormVisible = true;
        this.editForm = row;
        this.editForm.pro_status = row.pro_status.toString();
        this.editForm.recommend = row.recommend.toString();
        this.editForm.is_oversea = row.is_oversea.toString();
        this.editForm.add_cart = row.add_cart.toString();
        this.editForm.five_pifa = row.five_pifa.toString();
        this.editForm.one_daifa = row.one_daifa.toString();
        this.editForm.is_baoyou = row.is_baoyou.toString();

        //this.editForm.moban_id = row.moban_id.toString();
        this.proPic = row.pro_pic.split(',');
        this.prointroPic = row.prointro_pic.split(',');
        let that = this;
        this.fileListPro = [];
        this.proPic.forEach(function (item, i) {
          that.fileListPro.push({
            name: item.replace(basicdata.picUrl, ''),
            url: item
          })
        });
        this.fileListProintro = [];
        this.prointroPic.forEach(function (item, i) {
          that.fileListProintro.push({
            name: item.replace(basicdata.picUrl, ''),
            url: item
          })
        });
        this.mainPicUrl = row.pro_mainpic;
        //获取商品规格列表
        this.$axios.get(config.api_url + '/product/specification/' + row.pro_id
        ).then(response => {
          this.prospecTable = [];
          let i = 0
          for(const item of response.data.msg) {
            item.index = i;
            this.prospecTable.push(item);
            i++;
          }
        }).catch(error => {
          console.log(error)
        });
      },
      //修改提交
      editSubmit() {
        this.$refs.editForm.validate((valid) => {
          if (valid) {
            this.$confirm('确认提交吗？', '提示', {}).then(() => {
              this.submitLoading = true;
              let para = formatPara(Object.assign({}, this.editForm));
              para.prosales = parseInt(para.prosales);
              para.pro_pic = this.proPic.toString();
              para.prointro_pic = this.prointroPic.toString();
              para.pro_status = parseInt(para.pro_status);
              para.recommend = parseInt(para.recommend);
              para.pro_mainpic = this.mainPicUrl;
              para.beianjia = parseInt(para.beianjia);
              para.add_cart = parseInt(para.add_cart);
              para.five_pifa = parseInt(para.five_pifa);
              para.one_daifa = parseInt(para.one_daifa);
              para.is_baoyou = parseInt(para.is_baoyou);
              // para.moban_id = parseInt(para.moban_id);
              para.is_oversea = parseInt(para.is_oversea);
              para.referer_proid = parseInt(para.referer_proid);
              para.referer_specid = parseInt(para.referer_specid);
              //异步请求
              this.$axios.put(config.api_url + '/product',
                para).then(response => {
                if(response.data.state) {
                  //新增商品规格
                  this.addProspec(response.data.msg)
                  this.$message({
                    message: '提交成功',
                    type: 'success'
                  });
                  this.$refs['editForm'].resetFields();
                  this.mainPicUrl = '';
                  this.proPic = [];
                  this.prointroPic = [];
                  this.fileListPro = [];
                  this.fileListProintro = [];
                  this.prospecTable = [];
                  this.referer_proid = '';
                  this.referer_specid = '';
                  this.editFormVisible = false;
                  this.search();
                } else {
                  this.$message({
                    message: '提交失败，请联系管理员',
                    type: 'warning'
                  });
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '提交异常，请联系管理员',
                  type: 'error'
                });
              });
              this.submitLoading = false;
            });
          }
        });
      },
      addHandler() {
    
              this.addFormVisible = true;
              this.proPic = [];
              this.fileListPro = [];
              this.prointroPic = [];
              this.fileListProintro = [];
              this.mainPicUrl = '';
              this.prospecTable = [];
              this.referer_proid = '';
              this.referer_specid = '';
      },
      //上传图片到七牛
      beforeUpload(file) {
        this.imageName = 'product/' + formatDate(new Date(), 'yyyyMMddhhmmss') + Math.random().toString(36).substr(2);
        let mime = file.name.split('.')[1];
        this.imageName += '.' + mime;
        this.uploadForm.key = this.imageName;
        this.imageUrl = basicdata.picUrl + this.imageName;
      },
      //上传失败
      uploadError(error) {
        console.log(error);
        this.$message({
          message: '图片上传异常，请联系管理员',
          type: 'error'
        });
      },
      //商品图片上传
      uploadPro() {
        this.proPic.push(this.imageUrl);
        this.fileListPro.push({
          name: this.imageName,
          url: this.imageUrl
        })
      },
      //商品详情图片上传
      uploadProintro() {
        this.prointroPic.push(this.imageUrl);
        this.fileListProintro.push({
          name: this.imageName,
          url: this.imageUrl
        })
      },
      //商品图片删除
      removePicPro(file, fileList) {
        this.proPic = this.proPic.filter(x => x !== basicdata.picUrl + file.name);
           this.proPic = this.proPic.filter(x => x !== file.name);
      },
      //商品详情图片删除
      removePicProintro(file, fileList) {
        this.prointroPic = this.prointroPic.filter(x => x !== basicdata.picUrl + file.name);
        this.prointroPic = this.prointroPic.filter(x => x !== file.name);
      },
      //获取品牌列表
      getBrand() {
        this.$axios.get(config.api_url + '/brand/list'
        ).then(response => {
          let data = response.data;
          if(data.state) {
            for(const item of data.msg) {
              this.brand.push({
                label: item.brand_name,
                value: item.brand_id
              })
            }
          } else {
            this.$message({
              message: '获取品牌失败',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取品牌异常，请联系管理员',
            type: 'error'
          });
        });
      },
             //获取首页分类列表
      getIndexCategory() {
        this.$axios.get(config.api_url + '/indexcategory/list'
        ).then(response => {
          let data = response.data;
          if(data.state) {
            for(const item of data.msg) {
              this.indexcategory.push({
                label: item.category_name,
                value: item.category_id
              })
            }
          } else {
            this.$message({
              message: '获取首页分类失败',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取首页分类异常，请联系管理员',
            type: 'error'
          });
        });
      },
      //获取二级分类列表
      getSecondMenu() {
        this.$axios.get(config.api_url + '/menu/tree'
        ).then(response => {
          let data = response.data;
          if(data && data.length > 0) {
            for(const item of data) {
              for(const item1 of item.sec_menu) {
                this.secondMenu.push({
                  label: item1.sec_name,
                  value: item1.sec_id
                });
              }
            }
          } else {
            this.$message({
              message: '获取分类失败',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取分类异常，请联系管理员',
            type: 'error'
          });
        });
      },
      //上传商品主图片
      mainBeforeUpload (file) {
        let fileName = 'product/' + formatDate(new Date(), 'yyyyMMddhhmmss') + Math.random().toString(36).substr(2);
        let mime = file.name.split('.')[1];
        fileName += '.' + mime;
        this.uploadForm.key = fileName;
      },
      mainHandleSuccess (response, file, fileList) {
        this.mainPicUrl = basicdata.picUrl + this.uploadForm.key;
        this.result = '上传成功'
      },
      mainHandleError (error, response, file) {
        this.result = error.toString()
      },
      //获取规格列表
      getSpec() {
        this.$axios.get(config.api_url + '/specification/list'
        ).then(response => {
          for(const item of response.data.msg) {
            this.prospecArr.push({
              label: item.name,
              value: item.id
            })
          }
        }).catch(error => {
          console.log(error)
        });
      },
      //保存规格，暂存在本地
      saveSpec() {
        let para = this.prospecForm;
        para.is_default = parseInt(para.is_default);
        para.inventory = parseInt(para.inventory);
        para.cpprice = parseInt(para.cpprice);
        para.cost = parseInt(para.cost);
        para.market_price = parseInt(para.market_price);
        para.index = this.prospecTable.length;
        this.prospecTable.push(para)
        this.prospecForm = {
          spec_name: '',
          market_price: '',
          cpprice: '',
           cost: '',
          inventory: '',
          is_default: '0'
        };
      },
      //删除所有规格
      deleteSpec(id, index) {
        if(id > 0) {
          //删除数据库
          this.$axios.delete(config.api_url + '/product/specification/' + id
          ).then(response => {
            if(!response.data.state) {
              this.$message({
                message: '删除规格失败',
                type: 'warning'
              });
            }
          }).catch(error => {
            console.log(error);
            this.$message({
              message: '删除规格异常',
              type: 'error'
            });
          });
        }
        //删除数组
        this.prospecTable.splice(index, 1);
        for(let i = 0; i < this.prospecTable.length; i++) {
          this.prospecTable[i].index = i;
        }
      },
      //新增商品规格
      addProspec(proid) {
        this.$axios.post(config.api_url + '/product/specification/' + proid, this.prospecTable
        ).then(response => {
        }).catch(error => {
          console.log(error)
        })
      },
      // //修改规格
      // editSpecHandler(proid) {
      //   this.$router.push("/goods/prospec/" + proid);
      // },
           //打开更新宝贝
      updatePro(row) {
        this.updateProVisible = true;
        this.pro_id = row.pro_id ;
        this.copy_proid = row.copy_proid;
      },
            //修改更新宝贝
      updateProSubmit() {
        this.submitLoading = true;
        this.$axios.put(config.api_url + '/goods/updateprosubmit', {
          "pro_id": this.pro_id,
          "copy_title": parseInt(this.copy_title),
          "copy_proid": this.copy_proid
        }).then(response => {
          let data = response.data;
          if(data.state) {
            this.$message({
              message: '更新成功！',
              type: 'success'
            });
            this.submitLoading = false;
            this.updateProVisible = false;
            this.search();
          } else {
            this.$message({
              message: '更新宝贝失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '修改备注异常，请联系管理员',
            type: 'error'
          });
        })
      },
      //获取商品分类树
      showGoodsForm(row) {
        this.proid = row.pro_id;
        this.goodsData = [];
        this.selectGoodsData = [];
        this.selectGoodsVisible = true;
        this.$axios.get(config.api_url + '/menu/tree'
        ).then(response => {
          let data = response.data;
          if(data && data.length > 0) {
            let allmenu = [];
            for(const item of data) {
              if(item.sec_menu && item.sec_menu.length > 0) {
                let secMenu = [];
                for(const item1 of item.sec_menu) {
                  secMenu.push({
                    label: item1.sec_name,
                    value: item1.sec_id,
                    isFirst: 0
                  })
                }
                allmenu.push({
                  label: item.fname,
                  value: item.fid,
                  isFirst: 1,
                  children: secMenu
                })
              } else {
                allmenu.push({
                  label: item.fname,
                  value: item.fid,
                  isFirst: 1,
                })
              }
            }
            this.goodsTypeData = allmenu;
          } else {
            this.$message({
              message: '获取树失败',
              type: 'error'
            });
          }
        }).catch(error => {
          this.$message({
            message: '获取树异常，请联系管理员',
            type: 'error'
          });
        });
      },
      //点击树节点，获取商品
      handleNodeClick(data) {
        if(data.isFirst === 0) {
          this.$axios.get(config.api_url + '/product/type/'+data.value
          ).then(response => {
            let data = response.data;
            if(data && data.length > 0) {
              let goodsData = [];
              for(const item of data) {
                goodsData.push({
                  name: item.pro_name,
                  value: item.pro_id
                })
              }
              this.goodsData = goodsData;
              //获取已关联商品
              this.$axios.get(config.api_url + '/product/relateds/'+this.proid
              ).then(response => {
                if(response.data) {
                  let selectData = [];
                  for(const id of response.data.split(',')) {
                    for(const item of goodsData) {
                      if(item.value === parseInt(id)) {
                        selectData.push(item.name + '-' + id);
                      }
                    }
                  }
                  this.selectGoodsData = selectData;
                }
              }).catch(error => {
                console.log(error);
                this.$message({
                  message: '获取商品异常，请联系管理员',
                  type: 'error'
                });
              })
            } else {
              this.$message({
                message: '未获取到商品',
                type: 'info'
              });
            }
          }).catch(error => {
            console.log(error);
            this.$message({
              message: '获取商品异常，请联系管理员',
              type: 'error'
            });
          });
        }
      },
      //提交选择商品
      selectGoodsSubmit() {
        if(this.selectGoodsData && this.selectGoodsData.length > 0) {
          let proIds = [];
          for(const item of this.selectGoodsData) {
            proIds.push(item.split('-')[1]);
          }
          this.$axios.post(config.api_url + '/product/related', {
              related_proids: proIds.toString(),
              pro_id: this.proid
            }).then(response => {
            if(response.data.state) {
              this.$message({
                message: '提交成功',
                type: 'success'
              });
              this.selectGoodsVisible = false;
            } else {
              this.$message({
                message: '未获取到商品',
                type: 'info'
              });
            }
          }).catch(error => {
            this.$message({
              message: '获取商品异常，请联系管理员',
              type: 'error'
            });
          });
        }
      },
      onekeyCopy(pro_id) {
          this.$confirm('确认一键复制吗？', '提示', {}).then(() => {

    this.$axios.get(config.api_url + '/product/onekeycopy/'+pro_id
            ).then(response => {
              let data = response.data;
              if(data.state) {
                   this.$message({
                    message: '复制成功',
                    type: 'success'
                  });
                    this.search();
              } else {
                this.$message({
                  message: '一键复制失败',
                  type: 'warning'
                });
              }
            }).catch(error => {
              console.log(error);
              this.$message({
                message: '一键复制异常，请联系管理员',
                type: 'error'
              });
            });

           });
      },
            setWhiteList(pro_id) {
          this.$confirm('确认设置为白名单吗？', '提示', {}).then(() => {

    this.$axios.get(config.api_url + '/product/setwhitelist/'+pro_id
            ).then(response => {
              let data = response.data;
              if(data.state) {
                   this.$message({
                    message: '白名单成功',
                    type: 'success'
                  });
                    this.search();
              } else {
                this.$message({
                  message: '设置失败',
                  type: 'warning'
                });
              }
            }).catch(error => {
              console.log(error);
              this.$message({
                message: '设置异常，请联系管理员',
                type: 'error'
              });
            });

           });
      },
        deleteRemark(pro_id) {
          this.$confirm('确认清空备注上架吗？', '提示', {}).then(() => {

    this.$axios.get(config.api_url + '/product/deleteremark/'+pro_id
            ).then(response => {
              let data = response.data;
              if(data.state) {
                   this.$message({
                    message: '清空备注成功',
                    type: 'success'
                  });
                    this.search();
              } else {
                this.$message({
                  message: '清空备注失败',
                  type: 'warning'
                });
              }
            }).catch(error => {
              console.log(error);
              this.$message({
                message: '清空备注异常，请联系管理员',
                type: 'error'
              });
            });

           });
      },
      getDianpuList() {
        this.$axios.get(config.api_url + '/dianpu/list'
        ).then(response => {
          let data = response.data;
          if(data.state) {
            for(const item of data.msg) {
              this.dianpuList.push({
                label: item.dianpu_name,
                value: item.id
              });
            }
          } else {
            this.$message({
              message: '获取店铺失败',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取店铺异常，请联系管理员',
            type: 'error'
          });
        });
      },
      getKuaidiMoban() {
        this.$axios.get(config.api_url + '/kuaidi/moban'
        ).then(response => {
          if(response.data.state) {
            this.mobanArr = [];
            for(const item of response.data.msg) {
              this.mobanArr.push({
                label: item.name,
                value: item.id
              })
            }
          } else {
            this.$message({
              message: '获取快递模板失败，请联系管理员',
              type: 'warning'
            });
          }
        }).catch(error => {
          console.log(error);
          this.$message({
            message: '获取快递模板异常，请联系管理员',
            type: 'error'
          });
        });
      }
    },
     
    created() {
      this.search();
      this.getBrand();
      this.getIndexCategory();
      this.getSecondMenu();
      this.getSpec();
      this.getKuaidiMoban();
      this.getDianpuList();
    }
  }
</script>

<style scoped>
  .rightsearch{
    float: right;
  }
  .spec_border {
    border: 1px solid #dfe6ec;
    padding: 25px 30px 25px 20px;
    margin-bottom: 20px;
  }
  .select-goods {
    width: 100%;
  }
  .select-goods .goods-tree {
    width: 30%;
    height: 300px;
    overflow-y: scroll;
    float:left;
  }
  .select-goods .goods-data {
    cursor: default;
    background: #fff;
    border: 1px solid #d1dbe5;
    width: 60%;
    margin-left: 40%;
    height: 300px;
    overflow-y: scroll;
  }
  .el-checkbox {
    margin-left: 20px;
    margin-top: 7px;
  }
  .select-goods .no-goods {
    text-align: center;
    color: #5e7382;
    padding-top: 30%;
  }
  /* 自定义图片排序样式 */
  .image-sort-container {
    display: flex;
    flex-wrap: wrap;
    margin-top: 10px;
    border: 1px dashed #c0ccda;
    padding: 10px;
    background: #fbfdff;
    border-radius: 6px;
  }
  .image-sort-item {
    margin: 5px;
    padding: 5px;
    border: 1px solid #c0ccda;
    border-radius: 6px;
    background: #fff;
    text-align: center;
    width: 120px;
  }
  .sort-img {
    width: 110px;
    height: 110px;
    object-fit: contain;
    display: block;
    margin-bottom: 5px;
  }
  .sort-btns .el-button {
    padding: 0 4px;
    margin: 0;
  }
 /* ================= 商品主图加号居中及外框样式 ================= */
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  background: #fbfdff;
  
  /* 给容器定义明确的宽高 */
  width: 120px;   
  height: 120px;
  display: block; /* 改回 block，防止 flex 压缩图标 */
  transition: border-color 0.2s;
}

.avatar-uploader /deep/ .el-upload:hover {
  border-color: #20a0ff;
}

/* 核心：通过让 line-height 等于 height 实现垂直居中，text-align 实现水平居中 */
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 120px;
  height: 120px;
  line-height: 120px; 
  text-align: center;
  display: block;
}

/* 兼容可能存在的旧版图标库 */
.avatar-uploader-icon::before {
  display: inline-block;
}

/* 上传成功后的主图预览 */
.avatar {
  width: 120px;
  height: 120px;
  object-fit: contain;
  display: block;
}
</style>



// WEBPACK FOOTER //
// list.vue?7305f56f